import React from 'react';

import Media, { MediaProps } from '../../molecules/Media';

export interface GallerySectionProps {
    images: MediaProps['image'][];
}

export default function GallerySection({ images = [] }: GallerySectionProps) {
    return (
        <section className="my-mega">
            {!!images.length && (
                <div className="container flex flex-col gap-gutter md:flex-row">
                    {images.map((image, i) => {
                        return (
                            <div className="md:basis-[33%] rounded-large overflow-hidden w-full aspect-square relative">
                                <Media
                                    key={`gallery-image-${i}`}
                                    className=""
                                    media={image}
                                    layout="fill"
                                />
                            </div>
                        );
                    })}
                </div>
            )}
        </section>
    );
}
